import React from 'react';
import Select from 'react-select';

function DropdownType({ answers = [] }) {
  const answer = React.useMemo(() => {
    return answers.find(i => i.answer)
  }, [answers])
  return (
    <Select
      value={{
        value: answer?.answer,
        label: answer?.answer
      }}
      isDisabled
    />
  );
}

export default DropdownType;